import VCBusinessDetails from "./VCBusinessDetails";

export default VCBusinessDetails;
